import { showSuccessToast, showErrorToast } from '../../actions/notification-actions';
import {
    IMPORTED_EVENT_SHARE_COPIED_TOAST_TITLE,
    IMPORTED_EVENT_SHARE_COPIED_TOAST_MESSAGE,
    IMPORTED_EVENT_SHARE_FAILED_TOAST_TITLE,
    IMPORTED_EVENT_SHARE_FAILED_TOAST_MESSAGE,
} from './importedEventShareToast';

const notifyCopyFailed = (dispatch) => {
    dispatch(showErrorToast({
        title: IMPORTED_EVENT_SHARE_FAILED_TOAST_TITLE,
        message: IMPORTED_EVENT_SHARE_FAILED_TOAST_MESSAGE,
    }));
};

// `navigator.clipboard` is absent outside a secure context, and `writeText` rejects without a user
// gesture, so the missing-API case and a rejected write both land in the same catch — the fallback
// toast is the answer to either.
export const copyImportedEventShareLink = async (dispatch, shareUrl) => {
    if (!shareUrl) {
        notifyCopyFailed(dispatch);
        return false;
    }

    try {
        await navigator.clipboard.writeText(shareUrl);
    } catch (error) {
        console.error('Imported event share: could not copy link', error?.message);
        notifyCopyFailed(dispatch);
        return false;
    }

    dispatch(showSuccessToast({
        title: IMPORTED_EVENT_SHARE_COPIED_TOAST_TITLE,
        message: IMPORTED_EVENT_SHARE_COPIED_TOAST_MESSAGE,
    }));
    return true;
};
